import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NodeItemComponent } from './node-item/node-item.component';
import { RouteGuardService } from 'src/app/guards/route-guard.service';

const routes: Routes = [
    {
        path: 'node/:nodeId',
        component: NodeItemComponent,
        canActivate: [AuthGuard], //, RouteGuardService],
        data: {
            title: 'View Node'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class NodeRoutingModule {}
